import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import Breadcrumb from "./BreadCrumbs";
import ScrollToTop from '../utils/scrollToTop.js';
import { useState } from 'react';
import { Link } from 'react-router-dom';



export default function ContactUs() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    event.currentTarget.reset();
  };

  return (
    <div >
      <ScrollToTop />

      <section className="relative h-[320px] bg-cover bg-center sm:h-[400px]">
        {/* ✅ Hero Image with Overlay */}
        <div
    className="relative flex h-full w-full items-center justify-center text-white"
    style={{
      backgroundImage: `url('/shoenow.JPG')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundBlendMode: 'overlay',
    }}
  >

          {/* Overlay with Smooth Transition */}
          <div className="absolute inset-0 bg-black/40"></div>

          {/* Text on Top of the Overlay */}
          <h1 className="z-10 text-3xl font-bold sm:text-4xl">Reach Us</h1>
        </div>
      </section>

      {/* ✅ Breadcrumb Just Below the Hero Section */}
      <Breadcrumb />
      <div className="w-full h-[2px] bg-yellow-900"></div>

      <div className="mt-6 px-4">
        {/* Contact Info Section */}
        <div className="flex justify-center"> <h2 className="text-3xl font-bold text-center mb-8 text-green-700 border-b-2 border-yellow-900">Contact Us</h2></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 ">
          {/* Call Us Card */}
          <div className="rounded-xl border border-gray-200 bg-gradient-to-br from-white to-gray-100 p-6 text-center shadow-sm">
            <FaPhoneAlt className="text-green-800 text-4xl mx-auto mb-4" />
            <div className="flex justify-center"><h3 className="border-b-2 border-yellow-900 text-xl font-semibold text-gray-900">Call Us</h3></div>
            <p className=" mt-2 text-gray-700">+91 9425332127</p>
          </div>

          {/* Mail Us Card */}
          <div className="rounded-xl border border-gray-200 bg-gradient-to-br from-white to-gray-100 p-6 text-center shadow-sm">
            <FaEnvelope className="text-blue-500 text-4xl mx-auto mb-4" />
            <div className="flex justify-center"><h3 className="border-b-2 border-yellow-900 text-xl font-semibold text-gray-900">Mail Us</h3></div>
            <p className="mt-2 text-gray-700">sarang@vasundharaseeds.in</p>
          </div>

          {/* Location Card with Google Map */}
          <div className="rounded-xl border border-gray-200 bg-gradient-to-br from-white to-gray-100 p-6 text-center shadow-sm">
            <FaMapMarkerAlt className="text-red-500 text-4xl mx-auto mb-4" />
            <div className="flex justify-center"><h3 className="border-b-2 border-yellow-900 text-xl font-semibold text-gray-900">Reach Us</h3></div>
            <p className="mt-2 mb-4 text-gray-700">53 D Badi Udyogpuri, Ujjain, MP</p>

          </div>
        </div>
        <div className="w-full h-40 rounded-lg overflow-hidden">
          <iframe
            title="Google Map"
            className="w-full h-[200px]"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.8127678815176!2d75.81210517554797!3d23.177032679065885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3963747197b72967%3A0xa1e833c73156e647!2sVasundhara%20Seeds%2C%20Ujjain!5e0!3m2!1sen!2sin!4v1739965422649!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <section className="mx-auto mt-16 mb-4 max-w-4xl rounded-2xl bg-stone-50 p-6 shadow-sm ring-1 ring-stone-200 md:p-10" aria-labelledby="contact-form-title">
          <div className="text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-yellow-700">Send an enquiry</p>
            <h2 id="contact-form-title" className="mt-2 text-3xl font-bold text-green-800">How can we help?</h2>
            <p className="mt-3 text-gray-600">Tell us what you need and our team will get back to you.</p>
          </div>

          {submitted && (
            <div className="mt-6 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-center text-green-800" role="status">
              Thank you for contacting Vasundhara Seeds. Your enquiry has been submitted.
            </div>
          )}

          <form className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className="mb-2 block text-sm font-semibold text-gray-800">Full name <span aria-hidden="true">*</span></label>
              <input id="name" name="name" type="text" autoComplete="name" required className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 outline-none transition focus:border-green-700 focus:ring-2 focus:ring-green-200" placeholder="Your name" />
            </div>
            <div>
              <label htmlFor="phone" className="mb-2 block text-sm font-semibold text-gray-800">Phone number <span aria-hidden="true">*</span></label>
              <input id="phone" name="phone" type="tel" autoComplete="tel" required className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 outline-none transition focus:border-green-700 focus:ring-2 focus:ring-green-200" placeholder="Your phone number" />
            </div>
            <div>
              <label htmlFor="email" className="mb-2 block text-sm font-semibold text-gray-800">Email address <span aria-hidden="true">*</span></label>
              <input id="email" name="email" type="email" autoComplete="email" required className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 outline-none transition focus:border-green-700 focus:ring-2 focus:ring-green-200" placeholder="you@example.com" />
            </div>
            <div>
              <label htmlFor="subject" className="mb-2 block text-sm font-semibold text-gray-800">Subject</label>
              <input id="subject" name="subject" type="text" className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 outline-none transition focus:border-green-700 focus:ring-2 focus:ring-green-200" placeholder="How can we help?" />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="message" className="mb-2 block text-sm font-semibold text-gray-800">Message <span aria-hidden="true">*</span></label>
              <textarea id="message" name="message" rows="5" required className="w-full resize-y rounded-lg border border-gray-300 bg-white px-4 py-3 outline-none transition focus:border-green-700 focus:ring-2 focus:ring-green-200" placeholder="Please share your enquiry, product interest, or requirement." />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="rcs-consent" className="flex cursor-pointer items-start gap-3 text-sm text-gray-700">
                <input
                  id="rcs-consent"
                  name="rcsConsent"
                  type="checkbox"
                  value="yes"
                  className="mt-0.5 h-4 w-4 rounded border-gray-300 text-green-800 focus:ring-2 focus:ring-green-500"
                />
                <span>I agree to receive messages for communication via RCS.</span>
              </label>
            </div>
            <div className="md:col-span-2 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
              <p className="text-sm text-gray-600">By submitting, you agree to our <Link to="/privacy-policy" className="font-semibold text-green-800 underline underline-offset-2 hover:text-green-600">Privacy Policy</Link> and <Link to="/terms-and-conditions" className="font-semibold text-green-800 underline underline-offset-2 hover:text-green-600">Terms &amp; Conditions</Link>.</p>
              <button type="submit" className="rounded-lg bg-green-800 px-7 py-3 font-semibold text-white transition hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">Submit enquiry</button>
            </div>
          </form>
        </section>

        <div className="text-center mt-8">
          <a
            href="https://wa.me/919425332127"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-green-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-green-800 transition-all animate-pulse"
          >
            <span className="mr-2">Chat on WhatsApp</span>
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="w-10 h-10" />

          </a>
        </div>


        {/* <!-- Social Media --> */}
        <div className="text-center mt-8 py-10 text-green-700">
          <div className="flex justify-center "><h3 className="text-lg font-semibold mb-4 border-b-2 border-yellow-900">Connect With Us</h3></div>
          <div className="inline-flex items-center gap-8">
            <a href="https://m.facebook.com/Vasundharaseedsujjain/" className="bg-green-900 text-yellow-400 hover:bg-green-700 hover:text-white transition w-12 h-12 flex items-center justify-center rounded-full text-2xl">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.instagram.com/" aria-label="Instagram" className="bg-green-900 text-yellow-400 hover:bg-green-700 hover:text-white transition w-12 h-12 flex items-center justify-center rounded-full text-2xl">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://x.com/" aria-label="X (Twitter)" className="bg-green-900 text-yellow-400 hover:bg-green-700 hover:text-white transition w-12 h-12 flex items-center justify-center rounded-full text-2xl">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://youtube.com/@sarangmanage10?si=qEai_gMTGyKLr3xi" className="bg-green-900 text-yellow-400 hover:bg-green-700 hover:text-white transition w-12 h-12 flex items-center justify-center rounded-full text-2xl">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>
      </div>
      <div className="w-full h-[2px] bg-yellow-900"></div>

    </div>
  );
}
